import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue";
var _hoisted_1 = {
  key: 0
};
var _hoisted_2 = {
  key: 0,
  class: "header"
};
var _hoisted_3 = {
  key: 0,
  class: "header-title"
};
var _hoisted_4 = {
  key: 1,
  class: "footer"
};
import { ref, watch, nextTick } from '../../../adapter-vue';
import { TUITranslateService } from '@tencentcloud/chat-uikit-engine';
import { outsideClick } from '@tencentcloud/universal-api';
import { isPC, isH5, isUniFrameWork } from '../../../utils/env';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    // 是否展示 底部弹出对话框
    show: {
      type: Boolean,
      default: false
    },
    // 是否需要遮罩层，默认为true
    modal: {
      type: Boolean,
      default: true
    },
    // 弹出框内容区域高度(不包含遮罩), 默认为 fit-content
    height: {
      type: String,
      default: 'fit-content'
    },
    // 是否可以通过点击外部关闭弹出对话框, 默认为true
    // uniapp 仅支持点击蒙版关闭弹出对话框
    closeByClickOutside: {
      type: Boolean,
      default: true
    },
    // 上边框两角圆角角度，默认为 0px，即默认为直角
    borderRadius: {
      type: String,
      default: '0px'
    },
    // title 标题文本
    title: {
      type: String,
      default: ''
    },
    // 是否展示顶部关闭按钮, 默认不展示
    showHeaderCloseButton: {
      type: Boolean,
      default: false
    },
    // 是否展示底部提交按钮，默认不展示
    showFooterSubmitButton: {
      type: Boolean,
      default: false
    },
    // 底部提交按钮文案，仅 showFooterSubmitButton 为 true 时有效
    submitButtonContent: {
      type: String,
      default: () => TUITranslateService.t('确定')
    }
  },
  emits: ['onOpen', 'onClose', 'onSubmit'],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var props = __props;
    var emits = __emit;
    var dialogRef = ref();
    watch(() => props.show, (newVal, oldVal) => {
      if (newVal === oldVal) {
        return;
      }
      switch (newVal) {
        case true:
          emits('onOpen', dialogRef);
          nextTick(() => {
            // web h5 下生效
            if (isH5 && !isUniFrameWork) {
              if (props.closeByClickOutside) {
                outsideClick.listen({
                  domRefs: dialogRef.value,
                  handler: closeBottomPopup
                });
              }
            }
          });
          break;
        case false:
          emits('onClose', dialogRef);
          break;
      }
    });
    var closeBottomPopup = () => {
      if (isUniFrameWork || isH5) {
        emits('onClose', dialogRef);
      }
    };
    var submit = () => {
      emits('onSubmit');
      closeBottomPopup();
    };
    return (_ctx, _cache) => {
      return props.show ? (_openBlock(), _createElementBlock("div", _hoisted_1, [!_unref(isPC) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(['bottom-popup', _unref(isUniFrameWork) && 'bottom-popup-uni', !_unref(isPC) && 'bottom-popup-h5', !_unref(isPC) && props.modal && 'bottom-popup-modal']),
        onClick: closeBottomPopup
      }, [_createElementVNode("div", {
        ref_key: "dialogRef",
        ref: dialogRef,
        class: _normalizeClass(['bottom-popup-main', !_unref(isPC) && 'bottom-popup-h5-main']),
        style: _normalizeStyle({
          height: props.height,
          borderTopLeftRadius: props.borderRadius,
          borderTopRightRadius: props.borderRadius
        }),
        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
      }, [__props.title || __props.showHeaderCloseButton ? (_openBlock(), _createElementBlock("div", _hoisted_2, [__props.title ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(__props.title), 1)) : _createCommentVNode("", true), __props.showHeaderCloseButton ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "header-close",
        onClick: closeBottomPopup
      }, _toDisplayString(_unref(TUITranslateService).t("关闭")), 1)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "default"), __props.showFooterSubmitButton ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", {
        class: "footer-submit",
        onClick: submit
      }, _toDisplayString(__props.submitButtonContent), 1)])) : _createCommentVNode("", true)], 6)], 2)) : _renderSlot(_ctx.$slots, "default", {
        key: 1
      })])) : _createCommentVNode("", true);
    };
  }
});